import { render, staticRenderFns } from "./AccountingDetails.vue?vue&type=template&id=77760774&lang=pug"
import script from "./AccountingDetails.vue?vue&type=script&lang=ts"
export * from "./AccountingDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports